import policyMakerService from './PolicyMaker';
import cdgAuth from 'cdg-auth-sdk';
//import cdgAuth from '../cdg-auth-sdk';
import { AUTH_SDK_MODULES } from '../constants/appConstants';
import { COMPANY_CONFIG } from '../constants/companyConfig';

/**
 * Initializes CDG Auth SDK Configuration
 */
const cdgAuthInitializer = (token) => ({
  cdgAuthConfig: async () => {
    const customerId = COMPANY_CONFIG.customerId;

    const policyService = policyMakerService(token);

    const poolId = await policyService.getUserPoolId();
    const config = {
      applicationName: process.env.REACT_APP_APPLICATION_NAME,
      userPoolId: poolId,
      schemaType: 'cognito',
      customerId,
      env: process.env.REACT_APP_ENV,
      token: await policyService.getAccessToken(),
      applicationDescription:
        'Build smarter workflows to boost efficiency and consistency.',
      accessConfigArray: AUTH_SDK_MODULES.flatMap((module) =>
        module.actions.map((action) => ({
          module: module.module,
          module_description: module.description,
          action: action.name,
          action_description: action.description,
        }))
      ),
    };

    if (poolId && customerId && process.env.REACT_APP_APPLICATION_NAME) {
      console.log(JSON.stringify(config));
      cdgAuth.updateConfig(config);
    }
  },
});

export default cdgAuthInitializer;

/**
 * Check permission for a specific module + action
 */
export const checkPermission = async (token, module, action) => {
  const policyService = policyMakerService(token);

  const userId = await policyService.getUserId();
  const authPayload = {
    user_id: userId,
    action,
    module,
    application_name: process.env.REACT_APP_APPLICATION_NAME,
    customer_id: await policyService.getClientId(),
    env:
      process.env.REACT_APP_ENV === 'localhost'
        ? 'dev'
        : process.env.REACT_APP_ENV,
    token: await policyService.getAccessToken(),
  };

  const isAllowed = await cdgAuth.checkAuthorization(authPayload);
  return isAllowed;
};
